import React, { Component } from 'react'

class Corner extends Component {
  render () {
    const { direction, children, delay} = this.props
    return (
      <div className={`section section--2 animate corner-${direction}`} style={{transitionDelay: `${delay}s`}}>
        <div className='corner'>
          <div className='corner__wall corner__wall--extra-1' />
          <div className='corner__wall corner__wall--1' />
          <div className='corner__wall corner__wall--2'>
            <div className='corner__wall corner__wall--extra-2' />
          </div>
          <div className='corner__roof' />
        </div>
        { children }
      </div>
    )
  }
}

export default Corner



// WEBPACK FOOTER //
// ./src/components/Corner.js